// dependencies
import { useState } from "react"

// styles
import "./css/image-carousel.css"


const ImageCarousel = ({ imgs, ytLink }) => {
    // state based on presence of ytLink
    const [activeItem, setActiveItem] = useState(ytLink ? "video" : 0)

    // handle change active frame content
    const handleThumbnailClick = (index) => {
        setActiveItem(index)
    }

    return (
        <div className="carousel-container">
            {/* active frame */}
            <div className="active-frame">
                {activeItem === "video" && ytLink ? (
                    // active vid or playlist
                    <iframe
                        width="100%"
                        height="600px"
                        src={
                            ytLink.includes("list=")
                            ? `https://www.youtube.com/embed/videoseries?list=${
                                ytLink.split("list=")[1]
                                }`
                            : `https://www.youtube.com/embed/${ytLink.split("v=")[1]}`
                        }
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    // active img
                    <img
                        src={imgs[activeItem]}
                        alt="active"
                        onLoad={(e) => e.currentTarget.classList.add("loaded")}
                    />
                )}
            </div>


            {/* thumbnails */}
            <div className="thumbnails">
                {/* thumbnail vid */}
                {ytLink && (
                    <div
                        className={`thumbnail ${activeItem === "video" ? "active" : ""}`}
                        onClick={() => handleThumbnailClick("video")}
                        style={{
                            cursor: "pointer",
                            padding: "5px",
                            border: activeItem === "video" ? "2px solid green" : "2px solid rgba(255, 255, 255, 0)",
                            marginBottom: "10px",
                        }}
                    >
                        <div
                            style={{
                                position: "relative",
                                paddingBottom: "56.25%",
                                height: 0,
                            }}
                        >
                            <iframe
                                src={`https://www.youtube.com/embed/${ytLink.split("v=")[1]}`}
                                title="YouTube thumbnail"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    pointerEvents: "none",
                                }}
                                frameBorder="0"
                                allow="accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture"
                            ></iframe>
                        </div>
                    </div>
                )}

                {/* thumbnail imgs */}
                {imgs.map((src, index) => (
                    <div
                        key={index}
                        className={`thumbnail ${index === activeItem ? "active" : ""}`}
                        onClick={() => handleThumbnailClick(index)}
                        style={{
                            cursor: "pointer",
                            padding: "5px",
                            border: index === activeItem ? "2px solid green" : "2px solid rgba(255, 255, 255, 0)",
                            marginBottom: "10px",
                        }}
                    >
                        <img
                            src={src}
                            alt={`thumbnail-${index}`}
                            style={{ width: "100%", height: "auto" }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ImageCarousel
